import { HttpClient } from '@remodeling/base';
import querystring from 'query-string';
import { GetSrShopListRequest, GetSrShopListResponse } from '../../model';

export class GetSrShopListGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetSrShopListRequest) {
    const query = querystring.stringify(req);
    return await this.httpClient.request<GetSrShopListResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/sr/shops?${query}`,
    });
  }
}
